export default [
  {
    path: "/photos",

    component: () =>
      import(/* webpackChunkName: "albums" */ "@/views/photos/Photos"),
    children: [
      {
        path: "",
        name: "albums",
        meta: {
          layout: "LayoutSidebar"
        },
        component: () =>
          import(/* webpackChunkName: "albums" */ "@/views/photos/Albums")
      },
      {
        path: ":slug",
        name: "album",
        meta: {
          layout: "LayoutSidebar"
        },
        component: () =>
          import(/* webpackChunkName: "album" */ "@/views/photos/Album")
      }
    ]
  }
];
